import React, { Component } from 'react'

// import pR1 from '../assets/pR1.png'Slideshow
import pR2 from '../assets/pR2.png'
import pR3 from '../assets/pR3.png'
import pR4 from '../assets/pR4.png'
import pR5 from '../assets/pR5.png'
import pR6 from '../assets/pR6.png'
// import pR3 from '../assets/pR3.png'
import { NavLink } from 'react-router-dom';
import './EachSlideStyles.css'

const slideImages2 = [

  
  [pR4, 'U2b', 'A YouTube clone. User can search for and watch videos with controls, they will also see the real time stats of the views and subscriber counts. ','https://github.com/EventHorizonChinmay/Chinmays-u2b','https://chinmays-u2b.netlify.app/'] ,
  [pR5, 'Portfolio', "Chinmay's portfolio listing a few of the previous projects. The visitor can also send a message using the form in the contact us page which will reach Chinmay via email.",'https://github.com/EventHorizonChinmay/Chinmays-Portfolio.git','https://chinmay-g.netlify.app/'],
  [pR2, 'Generic Social Media', 'A CRUD social media app with "like" feature. Google login is used','Source','View'],
  [pR6, 'Map App', "A map app, showing an interactable world map. User can search location and places, and can also draw on this map and save the drawings.",'https://github.com/EventHorizonChinmay/Map_App_vue_mapbox','https://chinmay-g-map.netlify.app/'],
  [pR3, 'My Bike Store', 'Responsive website to add and remove cycling related products and accessories from a cart.','https://github.com/EventHorizonChinmay/MyBikeStore1','https://my-bike-store.netlify.app/'],
    ];
      // [IMG, Title, Description, Code, Website]

  class EachSlideMultiPage extends Component{
    render(){
    return (
    <div className="each-slide">
        <div className='slideImage'> 
            <img src={(slideImages2[this.props.projNo][0])} alt='' className='projSS'></img>
        </div>
        <h3 className="project-title"> {slideImages2[this.props.projNo][1]} </h3>
        <div className="proj-details">
            <div className='details'><p> {slideImages2[this.props.projNo][2]}</p></div>
            <div className='proj-btns'>
            <NavLink to={slideImages2[this.props.projNo][4]} className='proj-btn' target="_blank"> View  
                </NavLink>
                {/* <button href='www.google.com' className='proj-btn'> View  
                </button> */}
                {/* <a href='https://www.google.com' type='button' className='btn'></a> */}
                <NavLink to={slideImages2[this.props.projNo][3]}  className='proj-btn' target="_blank"> Source  
                </NavLink>
            </div> {/* proj-btns*/}
        </div> {/* proj-details*/}
    
          </div> //Bg image 
        // </div> 


  )
}
}
export default EachSlideMultiPage